 import user from '../developer/console/reducer';
 import router from '../router/router.reducer';

 
 export default {
   user,
   router,
 }
 